var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.012,
    height: 36,
    viewBox: "0 0 36.012 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "folder-saved-search-svgrepo-com",
    d: "M15.683.059a15.573,15.573,0,1,0,0,31.145A15.446,15.446,0,0,0,24.857,28.2l7.124,7.124a2.41,2.41,0,1,0,3.37-3.445l-7.087-7.087A15.555,15.555,0,0,0,15.683.059Zm0,4.793A10.78,10.78,0,1,1,4.9,15.636,10.751,10.751,0,0,1,15.683,4.852Zm0,0",
    transform: "translate(-0.105 -0.059)",
    fill: "#081831"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.eaf6e3b127854e6033970bc5355b64ab.svg";
export { ForwardRef as ReactComponent };